import { CommonModule } from '@angular/common';
import { AfterContentInit, Component, ContentChild, Input, OnDestroy, signal } from '@angular/core';
import { Subscription } from 'rxjs';

import { FormFieldControl } from './form-field.control';

@Component({
  selector: 'ctr-form-field',
  imports: [CommonModule],
  templateUrl: './form-field.component.html',
  styleUrl: './form-field.component.scss',
})
export class FormFieldComponent implements OnDestroy, AfterContentInit {
  // ****************************************************************************
  // * Decorated properties                                                     *
  // ****************************************************************************

  /**
   * Reference to the control inside the form field.
   */
  @ContentChild(FormFieldControl) control?: FormFieldControl<any>;

  @Input() type = 'input';

  /**
   * Label of the form field.
   */
  @Input() label?: string;

  // ****************************************************************************
  // * Public properties                                                        *
  // ****************************************************************************

  /**
   * Signal indicating whether the label should float.
   */
  shouldLabelFloat = signal(false);

  // ****************************************************************************
  // * Private properties                                                       *
  // ****************************************************************************

  /**
   * Subscription to the stateChanges observable of the control.
   */
  private stateChangesSubscription?: Subscription;

  // ****************************************************************************
  // * Angular lifecycle hooks                                                  *
  // ****************************************************************************

  /**
   * Lifecycle hook called after the content has been initialized.
   */
  ngAfterContentInit(): void {
    if (this.control && this.control.stateChanges) {
      this.stateChangesSubscription = this.control.stateChanges.subscribe(() => {
        if (this.control) {
          this.shouldLabelFloat.set(this.control.focused() || !this.control.empty);
        }
      });
    }
  }

  /**
   * Lifecycle hook called on component destruction.
   */
  ngOnDestroy(): void {
    this.stateChangesSubscription?.unsubscribe();
  }

  // ****************************************************************************
  // * Public methods                                                           *
  // ****************************************************************************

  /**
   * Handles the click event on the container element.
   * @param event The mouse event.
   */
  onContainerClick(event: MouseEvent): void {
    this.control?.onContainerClick(event);
  }
}
